import { render, staticRenderFns } from "./DraggableSection.vue?vue&type=template&id=754736fc"
import script from "./DraggableSection.vue?vue&type=script&lang=js"
export * from "./DraggableSection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports